import { render, staticRenderFns } from "./SigningProcedures.vue?vue&type=template&id=1702771e"
import script from "./SigningProcedures.vue?vue&type=script&lang=js"
export * from "./SigningProcedures.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports